<template>
  <div id="app">
    <v-app>
      <TheDrawer/>

      <TheToolbar/>

      <v-content>
        <div v-if="isLoggedIn">
          <v-container fluid grid-list-md>
            <v-layout child-flex row wrap>
              <router-view/>
            </v-layout>
          </v-container>
        </div>
        <Login v-else></Login>
      </v-content>

      <v-footer app class="pa-3">
        <v-spacer></v-spacer>
        <div v-if="false">
          &copy; {{ new Date().getFullYear() }}
          -
          <strong>On Purpose Solutions</strong>
        </div>
      </v-footer>
    </v-app>
  </div>
</template>

<style>
.theme--light.v-toolbar,
.theme--light.v-footer {
  background: none !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>

<script>
import Login from "./components/Login";
import TheToolbar from "./components/TheToolbar";
import TheDrawer from "./components/TheDrawer";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Login,
    TheToolbar,
    TheDrawer
  },
  created: function() {
    this.$store.dispatch("initUser");
  },
  computed: {
    ...mapGetters(["isLoggedIn", "userMeta"])
  }
};
</script>
